import { headers } from "../utils/utils";
const useRetiroStore = defineStore("retiro", () => {
  // state
  const retiro = ref({
    id: null,
    monto: 0,
    estatus: 2, // 1: Procesado 2: Pendiente 3: Rechazado
    usuario_id: null,
    datos_pago_id: null,
    movimiento_id: null,
    comprobante: null,
    mensajes: [],
    usuario: null,
    datos_pago: null,
    movimiento: null,
  });

  const retiros = ref([]);

  const estatusOptions = ref([
    { text: "Pendiente", value: 2 },
    { text: "Procesado", value: 1 },
    { text: "Rechazado", value: 3 },
  ]);

  // getters

  const draft = computed(() => clone(retiro.value));

  // mutations
  const setRetiro = (dp) => {
    if (dp) retiro.value = dp;
  };

  const setRetiros = (dps) => {
    if (dps) retiros.value = dps;
  };

  const clear = () => {
    retiro.value = {
      id: null,
      monto: 0,
      estatus: 2, // 1: Procesado 2: Pendiente 3: Rechazado
      usuario_id: null,
      datos_pago_id: null,
      movimiento_id: null,
      comprobante: null,
      mensajes: [],
      usuario: null,
      datos_pago: null,
      movimiento: null,
    };
  };

  // actions

  const fetch = async (retiro_id) => {
    try {
      const { data } = await axios.get(`/api/retiros/${retiro_id}/fetch-data`);
      setRetiro(data);
      return data;
    } catch (error) {
      console.error("Error fetching retiro:", error);
    }
  };

  const fetchData = async (params) => {
    try {
      const { data } = await axios.post(`/api/retiros/fetch-data`, params);
      return data;
    } catch (error) {
      console.error("Error fetching retiros:", error);
      throw error;
    }
  };

  const guardar = async (datos) => {
    try {
      if (datos.id) {
        const { data } = await axios.put(`/api/retiros/${datos.id}`, datos);
        if (data.result) {
          setRetiro(data.retiro);
        }

        return data;
      } else {
        const { data } = await axios.post(`/api/retiros`, datos);

        if (data.result) {
          setRetiro(data.retiro);
        }

        return data;
      }
    } catch (error) {
      console.error("Error saving retiro:", error);
      throw error;
    }
  };

  const eliminar = async (retiro_id) => {
    try {
      const { data } = await axios.delete(`/api/retiros/${retiro_id}`);
      if (data.result) {
        clear();
      }
      return data;
    } catch (error) {
      console.error("Error deleting retiro:", error);
      throw error;
    }
  };

  const obtenerDatosTarjeta = async (retiro_id) => {
    try {
      if (retiro_id === null) {
        return null;
      }
      const { data } = await axios.get(
        `/api/retiros/${retiro_id}/datos-tarjeta`
      );
      return data;
    } catch (error) {
      console.error("Error fetching datos tarjeta:", error);
      throw error;
    }
  };

  const procesar = async (params) => {
    let formData = new FormData();
    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    formData.append("_method", "PUT");
    try {
      const { data } = await axios.post(
        `/api/retiros/${params.id}/procesar-retiro`,
        formData,
        { headers }
      );

      if (data.result) {
        setRetiro(data.retiro);
      }

      return data;
    } catch (error) {
      throw error;
      console.error("Error processing retiro:", error);
    }
  };

  const aperturarChat = async (retiro_id) => {
    try {
      if (retiro_id === null) {
        throw new Error("El ID del retiro es nulo");
      }
      const { data } = await axios.get(
        `/api/retiros/${retiro_id}/aperturar-chat`
      );
      return data;
    } catch (error) {
      console.error("Error aperturando chat:", error);
      throw error;
    }
  };

  const enviarMensaje = async (retiro_id, mensaje) => {
    try {
      if (retiro_id === null) {
        throw new Error("El ID del retiro es nulo");
      }
      const { data } = await axios.put(
        `/api/retiros/${retiro_id}/enviar-mensaje`,
        mensaje
      );
      return data;
    } catch (error) {
      console.error("Error enviando mensaje:", error);
      throw error;
    }
  };

  return {
    //state and getters
    retiro,
    retiros,
    draft,
    estatusOptions,
    //methods
    setRetiro,
    setRetiros,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    obtenerDatosTarjeta,
    procesar,
    aperturarChat,
    enviarMensaje,
  };
});

export default useRetiroStore;
